import { TranslateService } from "@ngx-translate/core";
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
	providedIn: "root",
})
export class ToasterMessagesService {
	constructor(
		private messageService: MessageService,
		private TranslateService: TranslateService
	) {}

	setLanguageDirection(dir: string) {
		document.documentElement.dir = dir;
	}

	showSuccess(
		message: string,
		stickyOption: boolean = false,
		duration: number = 3000
	) {
		const position = this.getPositionBasedOnLanguage();
		this.messageService.add({
			severity: "success",
			detail: this.TranslateService.instant(message),
			sticky: stickyOption,
			// key:position,
			life: duration,
		});
	}

	showError(
		message: string,
		stickyOption: boolean = false,
		duration: number = 3000
	) {
		const position = this.getPositionBasedOnLanguage();
		this.messageService.add({
			severity: "error",
			detail: this.TranslateService.instant(message),
			sticky: stickyOption,
			// key:position,
			life: duration,
		});
	}

	showWarning(
		message: string,
		stickyOption: boolean = false,
		duration: number = 3000
	) {
		const position = this.getPositionBasedOnLanguage();
		this.messageService.add({
			severity: "warn",
			detail: this.TranslateService.instant(message),
			sticky: stickyOption,
			// key:position,
			life: duration,
		});
	}

	showInfo(
		message: string,
		stickyOption: boolean = false,
		duration: number = 3000
	) {
		const position = this.getPositionBasedOnLanguage();
		this.messageService.add({
			severity: "info",
			detail: this.TranslateService.instant(message),
			sticky: stickyOption,
			// key:position,
			life: duration,
		});
	}

	
	clearToasters() {
		this.messageService.clear();
	}

	private getPositionBasedOnLanguage(): string {
		const languageDirection = document.documentElement.dir;
		return languageDirection === "rtl" ? "bottomright" : "bottomleft";
	}


	showToast(
    message: string,
    isHtml: boolean = false,
    stickyOption: boolean = false,
    duration: number = 3000,
) {
    const position = this.getPositionBasedOnLanguage();
    
    const messageOptions: any = {
        severity: "info",
        sticky: stickyOption,
        life: duration,
    };

    if (isHtml) {
        messageOptions.content = message; // For HTML content
    } else {
        messageOptions.detail = this.TranslateService.instant(message); // For plain text
    }

    this.messageService.add(messageOptions);
}
}
